export const isBusinessFormPage = (pathname: string) => {
  const patterns = [
    /^\/business\/.*\/products\/create/,
    /^\/business\/.*\/products\/edit/,
    /^\/business\/.*\/settings\/account-data/,
  ];
  return patterns.some(pattern => pattern.test(pathname));
};

export const isUserFormPage = (pathname: string) =>
  ['/settings/register-business'].some(prefix => pathname.startsWith(prefix));
